import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import ACTButton from "./ACTButton";

// Why the phone ended the session early (StartWebSession onStatus endReason, SID-2471)
const END_MESSAGES = {
  declined: "The session was declined in the ACT Verify app.",
  replaced: "The session was replaced by another one on the phone.",
  ended: "The session was ended in the ACT Verify app.",
};

const SessionEndedPanel = (props) => {
const {goToHomePanel, onGenerateQR, refreshQrCode, endReason} = props;

  return (
    <Box>
      <Typography
        sx={{
          maxWidth: "18rem",
          fontSize: "1.2rem",
          fontWeight: "500",
          lineHeight: "1.1",
          margin: "1rem auto 2rem auto",
        }}
      >
        {END_MESSAGES[endReason] ?? "Your session has now ended."}
      </Typography>

      <Typography
        sx={{
          maxWidth: "12.5rem",
          fontSize: "0.9rem",
          fontWeight: "500",
          lineHeight: "1.2",
          margin: "2rem auto 0 auto",
        }}
      >
        If you wish to continue
      </Typography>
      <Box
        sx={{
          width: "17rem",
          margin: "1rem auto 0 auto",
        }}
      >
        <ACTButton
          content="request New QR Code"
          onClick={onGenerateQR}
          bgColor="#E54F9C"
          textColor="#ffffff"
          hoverColor="#b33b78"
          hoverTextColor="#ffffff"
          border="0.1rem solid #E54F9C"
          hoverBorder="0.1rem solid #b33b78"
        />
      </Box>
    </Box>
  );
};

export default SessionEndedPanel;
